import { Component } from "@angular/core";
import { Advert } from "../../../models/advert";
import { NavParams } from "ionic-angular";

@Component({
    selector: 'blank-desktop-page',
    templateUrl: 'blank.html'
})
export class BlankDesktopPage {

    public advert: Advert;

    constructor(
        public navParams: NavParams,
    ) {
        this.advert = this.navParams.get('advert') || null;
    }

}



// WEBPACK FOOTER //
// ./src/pages/desktop/blank/blank.ts